import { render, staticRenderFns } from "./Transfers.vue?vue&type=template&id=3e2048da&scoped=true&"
import script from "./Transfers.vue?vue&type=script&lang=js&"
export * from "./Transfers.vue?vue&type=script&lang=js&"
import style0 from "./Transfers.vue?vue&type=style&index=0&id=3e2048da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2048da",
  null
  
)

export default component.exports